module.exports = {"520281001":"亦资街道","520281002":"翰林街道","520281003":"两河街道","520281004":"红果街道","520281005":"胜境街道","520281006":"刘官街道","520281104":"民主镇","520281105":"大山镇","520281106":"保田镇","520281109":"石桥镇","520281111":"响水镇","520281117":"柏果镇","520281121":"新民镇","520281123":"盘关镇","520281124":"竹海镇","520281125":"英武镇","520281126":"鸡场坪镇","520281127":"双凤镇","520281128":"丹霞镇","520281129":"乌蒙镇","520281202":"普田回族乡","520281208":"坪地彝族乡","520281210":"淤泥彝族乡","520281211":"普古彝族苗族乡","520281212":"旧营白族彝族苗族乡","520281213":"羊场布依族白族苗族乡","520281214":"保基苗族彝族乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/520281.json
// module id = 2461
// module chunks = 0